// components/Footer/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 DBalambrados. Todos los derechos reservados.</p>
    </footer>
  );
};

export default Footer;